export function trackEvent(
  eventName: string,
  eventCategory: string,
  eventLabel: string,
  description: string,
  customParam?: Record<string, string>,
): void {
  if (typeof window.gtag !== 'function') {
    return;
  }

  window.gtag?.('event', eventName, {
    event_category: eventCategory,
    event_label: eventLabel,
    description,
    ...customParam,
  });
}
